export const DOWNLOAD_QUOTES_STEPS = ['Descargar plantilla', 'Subir plantilla', 'Resumen'];
